import { createBrowserHistory } from 'history';

export const BASE_URL = process.env.NODE_ENV === 'development' ? '' : 'public/wb/start';
export const history = createBrowserHistory({
	basename: BASE_URL,
});
